import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IImportsCoutersState, IImportsState, ModeTypes } from './types';

const initialState: IImportsState = {
  mode: ModeTypes.selectFile,
  importedCount: 0,
  failedCount: 0,
  totalCount: 0,
  warningsCount: 0,
  failedLogId: '',
  serverError: '',
  coreSignalConnectionId: null,
  numberOfRows: undefined,
  sessionId: '',
};

const STORE_NAME = '@imports';

const importsStore = createSlice({
  name: STORE_NAME,
  initialState,
  reducers: {
    setConnectionId: (
      state,
      { payload }: PayloadAction<IImportsState['coreSignalConnectionId']>
    ): void => {
      state.coreSignalConnectionId = payload;
    },
    sendUploadRequest: (state, _: PayloadAction<File>): void => {
      state.mode = ModeTypes.uploadStarted;
    },
    setMode: (state, { payload }: PayloadAction<ModeTypes>): void => {
      state.mode = payload;
    },
    setCounters: (
      state,
      { payload }: PayloadAction<IImportsCoutersState>
    ): IImportsState => {
      if (
        state.mode === ModeTypes.uploadFinished ||
        state.mode === ModeTypes.serverError
      ) {
        return state;
      }

      return {
        ...state,
        ...payload,
      };
    },
    setSessionId: (state, { payload }: PayloadAction<string>): void => {
      state.sessionId = payload;
    },
    setFailedLogId: (state, { payload }: PayloadAction<string>): void => {
      state.failedLogId = payload;
    },
    setServerError: (state, { payload }: PayloadAction<string>): void => {
      state.serverError = payload;
    },
    reset: (state): IImportsState => ({
      ...initialState,
      coreSignalConnectionId: state.coreSignalConnectionId,
    }),
    setNumberOfRows: (
      state,
      { payload: numberOfRows }: PayloadAction<number>
    ) => {
      state.numberOfRows = numberOfRows;
    },
  },
});

export const IMPORTS_SEND_UPLOAD_REQUEST = '@imports/sendUploadRequest';
export const IMPORTS_DOWNLOAD_REPORT = '@imports/downloadReport';
export const IMPORTS_INIT_CONNECT = '@imports/initConnect';
export const IMPORTS_DISCONNECT = '@imports/disconnect';

export const importsActions = {
  ...importsStore.actions,
  downloadReport: createAction(IMPORTS_DOWNLOAD_REPORT),
  coreSignalrConnect: createAction(IMPORTS_INIT_CONNECT),
  coreSignalrDisconnect: createAction(IMPORTS_DISCONNECT),
};

export const importsReducer = importsStore.reducer;
